import React from "react";

export default ({ isActive, children, sub }) => {
    const className = sub ? "o-submenu" : "o-menu";

    return (
        <div className={ `${ className } u-slide-in${ isActive ? " u-slide-in--active" : "" }` }>
            { children }
        </div>
    );
}
